/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ApplicationView } from '@gh/builder-shared-data';

import { AuthGuard } from '@gh/common-shared';
import { Enum } from '@gh/core-data';
import { arrayify } from '@gh/core-util';

import { isEmpty } from 'lodash';

import { BuilderUserContext } from '../user';

@Injectable()
export class BuilderAuthGuard extends AuthGuard {
  constructor(protected router: Router,
              protected userContext: BuilderUserContext) {
    super(router, userContext);
  }

  protected verifyRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const applicationView = arrayify(route.data['applicationView']);

    const isAppViewAllowed = isEmpty(applicationView) || this.verifyEntity(
      applicationView,
      (av) => Enum.exists(ApplicationView, av) && this.userContext.applicationView === av);

    // if given route does not belong to current application view => do not navigate
    if (!isAppViewAllowed) {
      return false;
    }

    if (this.userContext.applicationView === ApplicationView.Office) {
      // verify permissions in office view
      return super.verifyRoute(route, state);
    } else {
      return true;
    }
  }
}
